'use client';
import sendOpenTelemetryEvent from './sendOpenTelemetryEvent';
import { useEffect } from 'react';

export const ImageErrorListener = () => {
  const imgSrcSuffix = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.bmp',
    '.tiff',
    '.ico',
  ];
  useEffect(() => {
    const handleImageError = (event: Event) => {
      const img = event.target as HTMLImageElement;
      // filter only image errors
      if (img && imgSrcSuffix.some((suffix) => img.src.endsWith(suffix))) {
        sendOpenTelemetryEvent(
          'image-failed-event',
          'Image failed to load: ' + img.src
        );
      }
    };
    document.addEventListener('error', handleImageError, true);

    return () => {
      document.removeEventListener('error', handleImageError, true);
    };
  }, []);
  return <></>;
};
